import { useState, useEffect } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '介護保険を利用できますか？',
      answer: 'はい、当事業所は介護保険指定事業者です。要介護認定を受けている方は介護保険を利用してサービスをご利用いただけます。自己負担額は所得に応じて1〜3割となります。'
    },
    {
      question: 'サービスの利用時間はどのくらいですか？',
      answer: 'ケアプランに基づき、30分から90分程度のサービスが一般的です。ご利用者様の状態やご希望に応じて、適切な時間を設定いたします。'
    },
    {
      question: '急な依頼にも対応してもらえますか？',
      answer: 'できる限り対応させていただきますが、スケジュールの都合上、即日対応が難しい場合もございます。まずはお電話でご相談ください。'
    },
    {
      question: 'ヘルパーの指名はできますか？',
      answer: 'はい、可能です。ただし、スケジュールの都合上、ご希望に添えない場合もございます。担当ヘルパーとの相性は大切ですので、ご遠慮なくご相談ください。'
    },
    {
      question: '家族が不在でもサービスを受けられますか？',
      answer: 'はい、ご家族が不在でもサービスをご利用いただけます。鍵のお預かりなど、安全に配慮した方法でサービスを提供いたします。'
    },
    {
      question: 'どのような資格を持ったヘルパーが来ますか？',
      answer: '介護福祉士または介護職員初任者研修（旧ヘルパー2級）以上の資格を持ったヘルパーが訪問いたします。経験豊富なスタッフが丁寧にサポートいたします。'
    },
    {
      question: 'サービス内容の変更はできますか？',
      answer: 'はい、ご利用者様の状態やご希望の変化に応じて、サービス内容を変更することができます。ケアマネージャーと相談の上、柔軟に対応いたします。'
    }
  ];

  useEffect(() => {
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map(faq => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer
        }
      }))
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(faqSchema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <section className="py-24 bg-white observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-16 text-center">
          よくある質問
        </h2>

        <div className="max-w-4xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-md transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <span className="text-lg font-bold text-gray-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-cyan-600 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              
              {openIndex === index && (
                <div className="px-8 pb-6 bg-gray-50">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
